import type { LogoOrganization } from './logo-organization';

export { Role, RolePermission } from '@yandex-360/telemost-sdk/models';
export type {
    AvatarPlaceholderData,
    AvatarData,
    UserData,
    GetMeUserResponse,
    PublicRolePermissionInfo,
    Reaction,
    ReactionType,
} from '@yandex-360/telemost-sdk/cloud-api';

export enum PersonalPermission {
    CAMERA_MUTE = 'camera_mute',
    MICROPHONE_MUTE = 'microphone_mute',
    DESKTOP = 'desktop',
    DESKTOP_MUTE = 'desktop_mute',
    CLOSE_ROOM = 'close_room',
    ACCESS_LEVEL_EDIT = 'access_level_edit',
    RECORDING = 'recording',
    RECORDING_MUTE = 'recording_mute',
    RECORDING_BAN_ROLE = 'recording_ban_role',
    REACTION = 'reaction',
    REACTION_MUTE = 'reaction_mute',
    REACTIOM_MUTE_ALL = 'reaction_mute_all',
    REACTION_EDIT_MATRIX = 'reaction_edit_matrix',
    ADMIT = 'admit',
    ADMIT_ALL = 'admit_all',
    CLOUD_RECORDING_EDIT_MATRIX = 'cloud_recording_edit_matrix',
    CLOUD_RECORDING_BAN_ALL = 'cloud_recording_ban_all',
    CLOUD_RECORDING_BAN_ROLE = 'cloud_recording_ban_role',
    SUMMARIZATION_EDIT_MATRIX = 'summarization_edit_matrix',
    SUMMARIZATION_BAN_ALL = 'summarization_ban_all',
    SUMMARIZATION_BAN_ROLE = 'summarization_ban_role',
    SUMMARIZATION_SETTINGS = 'summarization_settings',
    CONFERENCE_PERMISSIONS_EDIT_MATRIX = 'conference_permissions_edit_matrix',
}

export const reactions = ['hand'] as const;

export interface AvatarPlaceholder {
    abbreviation: string;
    backgroundColor: string;
    textColor: string;
}

export type UserUid = string;

export type YandexUid = string;

export type DisplayName = string;

export type AvatarUrl = string;

export interface User {
    uid: UserUid;
    yandexuid?: YandexUid;
    login: string;
    name: string;
    avatarUrl: AvatarUrl;
    avatarPlaceholder: AvatarPlaceholder;
    accessToken?: string;
    isYandexTeamUser?: boolean;
    lang?: string;
    avatarId: string;
    isConnectAdmin: boolean;
    hasPlus: boolean;
    timezone: string;
    enabledNoB2cTariffPromo?: boolean;
    isB2b: boolean;
    hasProSubscription: boolean;
    hosted: boolean;
    displayName: DisplayName;
    isDefaultAvatar: boolean;
    broadcastAllowed: boolean;
    broadcastFeatureEnabled: boolean;
    passportUpgradeUrl?: string;
    canCreateOrganizationRestrictedConference?: boolean;
    isYandexSsoUser?: boolean;
    organizationIds?: Array<string>;
    isLegalEntity?: boolean;
    isPDD?: boolean;
    isSSO?: boolean;
    logoOrganization: LogoOrganization;
    bandwidthEffective4kCodecExp?: boolean;
}
